import React from 'react';

import MetricsAdmin from './MetricsAdmin';

// The admin landing page (Übersicht) is where the Kennzahlen live.
const Dashboard = () => <MetricsAdmin />;


export default Dashboard;
